/* SOVOR calculator report-card recommendations v1. */
(function () {
  'use strict';
  var form = document.getElementById('protein-calc-form');
  if (!form || document.getElementById('sovor-recommendations')) return;

  var plans = {
    vegetarian: [
      ['Moong dal chilla + curd', '18–23g', '₹30–55', '20 min', 'moong dal, curd, spices'],
      ['Paneer bhurji + two rotis', '24–29g', '₹60–100', '15 min', 'paneer, onion, tomato, roti'],
      ['Chana and curd bowl', '15–21g', '₹25–50', '10 min', 'boiled chana, curd, vegetables'],
      ['Sattu drink + curd', '17–21g', '₹25–50', '5 min', 'sattu, curd, water, lemon'],
    ],
    vegan: [
      ['Tofu bhurji + roti', '18–25g', '₹60–110', '15 min', 'tofu, vegetables, roti'],
      ['Soya chunk pulao', '25–31g', '₹35–65', '25 min', 'soya chunks, rice, vegetables'],
      ['Chana and peanut chaat', '16–22g', '₹25–50', '10 min', 'chana, peanuts, onion, tomato'],
      ['Dal and tofu rice bowl', '20–27g', '₹45–80', '25 min', 'dal, tofu, rice, vegetables'],
    ],
    non_vegetarian: [
      ['Egg bhurji + two rotis', '20–25g', '₹25–45', '10 min', 'eggs, vegetables, roti'],
      ['Chicken and dal bowl', '28–35g', '₹60–110', '25 min', 'chicken, dal, rice or roti'],
      ['Curd, fruit and seed bowl', '15–20g', '₹30–60', '5 min', 'curd, fruit, seeds'],
      ['Egg and chana salad', '20–26g', '₹35–65', '12 min', 'eggs, chana, vegetables'],
    ],
  };

  function value(name) { var e = form.querySelector('[name="' + name + '"]'); return e ? e.value : ''; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function addPracticalQuestions() {
    if (form.querySelector('[data-sovor-practical]')) return;
    var submit = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!submit) return;
    var fields = document.createElement('fieldset');
    fields.setAttribute('data-sovor-practical', 'true');
    fields.className = 'sovor-practical-fields';
    fields.innerHTML = '<legend>Make your recommendations practical <span>(optional)</span></legend>' +
      '<p class="sovor-practical-intro">Your answers help us choose meals that fit your budget and routine. They do not change the protein calculation.</p>' +
      '<div class="sovor-practical-grid">' +
      '<label>Daily food budget<select name="daily_food_budget"><option value="">Select budget</option><option value="under_75">Under ₹75</option><option value="75_150">₹75–150</option><option value="150_300">₹150–300</option><option value="300_plus">₹300+</option><option value="unsure">Not sure</option></select></label>' +
      '<label>Time for preparation<select name="cooking_time"><option value="">Select time</option><option value="under_10">Under 10 minutes</option><option value="10_20">10–20 minutes</option><option value="20_40">20–40 minutes</option><option value="enjoy">I enjoy cooking</option></select></label>' +
      '<label>Food access<select name="food_access"><option value="">Select access</option><option value="home_kitchen">Home kitchen</option><option value="shared_kitchen">Shared or hostel kitchen</option><option value="cafeteria">Cafeteria or tiffin</option><option value="ready_to_eat">Mostly ready-to-eat</option></select></label>' +
      '</div>';
    form.insertBefore(fields, submit);
  }
  function render() {
    if (document.getElementById('sovor-recommendations')) return;
    var result = document.getElementById('calculator-results');
    if (!result || getComputedStyle(result).display === 'none') return;
    var diet = value('diet') || 'vegetarian';
    var goal = value('goal') || 'general_wellness';
    var activity = value('activity') || 'sedentary';
    var mealPattern = value('diet_meals') || 'average';
    var budget = value('daily_food_budget');
    var cookingTime = value('cooking_time');
    var foodAccess = value('food_access');
    var gap = parseFloat((document.getElementById('result-gap') || {}).textContent || '0') || 0;
    var list = (plans[diet] || plans.vegetarian).slice();
    if (goal === 'muscle_building' || activity === 'very_active' || gap >= 20) list.sort(function (a, b) { return parseInt(b[1], 10) - parseInt(a[1], 10); });
    else if (budget === 'under_75' || mealPattern === 'light') list.sort(function (a, b) { return parseInt(a[2].replace(/[^0-9]/g, ''), 10) - parseInt(b[2].replace(/[^0-9]/g, ''), 10); });
    if (cookingTime === 'under_10' || foodAccess === 'ready_to_eat' || foodAccess === 'cafeteria') list.sort(function (a, b) { return parseInt(a[3], 10) - parseInt(b[3], 10); });
    if (budget === '150_300' || budget === '300_plus') list.sort(function (a, b) { return parseInt(b[1], 10) - parseInt(a[1], 10); });
    list = list.slice(0, 3);
    var section = document.createElement('section');
    section.id = 'sovor-recommendations';
    section.innerHTML = '<h2>Food-first recommendations for your routine</h2>' +
      '<p>These ideas are selected for your dietary pattern, goal and routine. Values are approximate and vary by portion, recipe and brand. This is informational, not medical advice.</p>' +
      '<div class="gsvc-pillars">' + list.map(function (r) { return '<article class="gsvc-pillar"><span class="num">' + esc(r[3]) + '</span><h3>' + esc(r[0]) + '</h3><p><strong>' + esc(r[1]) + '</strong> approximate protein · ' + esc(r[2]) + '</p><p>' + esc(r[4]) + '</p></article>'; }).join('') + '</div>' +
      '<div class="gsvc-note"><strong>Food first.</strong> If your meals consistently fall short, discuss your estimate with a doctor or registered dietitian before changing supplements.</div>' +
      '<p><button type="button" class="gsvc-btn gsvc-btn--gold" id="sovor-share-recipes">Share these recipe ideas</button></p>';
    result.insertAdjacentElement('afterend', section);
    var share = document.getElementById('sovor-share-recipes');
    if (share) share.addEventListener('click', function () {
      var event = { event: 'protein_recipe_share_clicked', calculator_version: '2026-09', share_channel: 'native' };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(event);
      if (typeof window.gtag === 'function') window.gtag('event', event.event, { calculator_version: event.calculator_version, share_channel: event.share_channel });
      var message = 'Indian protein recipe ideas — calculate your own protein target: https://sovor.store/pages/protein-calculator-india';
      if (navigator.share) navigator.share({ title: 'SOVOR protein recipe ideas', text: message, url: 'https://sovor.store/pages/protein-calculator-india' }).catch(function () {});
      else if (navigator.clipboard) navigator.clipboard.writeText(message).then(function () { share.textContent = 'Link copied'; });
    });
  }
  addPracticalQuestions();
  form.addEventListener('submit', function () { setTimeout(render, 700); }, { capture: true });
})();
